const CircleUserIcon = ({ className, fill }) => {
  return (
    <svg
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect x="0.5" width="48" height="48" rx="24" fill="#E6EEFF" />
      <path
        d="M24.2501 13.25C21.3506 13.25 19.0001 15.6005 19.0001 18.5C19.0001 21.3995 21.3506 23.75 24.2501 23.75C27.1496 23.75 29.5001 21.3995 29.5001 18.5C29.5001 15.6005 27.1496 13.25 24.2501 13.25Z"
        fill={fill || "#0051FF"}
      />
      <path
        d="M30.475 27.0771C30.314 26.9862 30.1717 26.9059 30.0563 26.8372C26.5022 24.7209 21.9981 24.7209 18.444 26.8372C18.3277 26.9064 18.184 26.9875 18.0214 27.0793C17.3086 27.4814 16.2311 28.0893 15.4929 28.8118C15.0312 29.2637 14.5926 29.8592 14.5128 30.5888C14.428 31.3646 14.7665 32.0927 15.4455 32.7396C16.617 33.8556 18.0227 34.75 19.841 34.75H28.6593C30.4776 34.75 31.8834 33.8556 33.0548 32.7396C33.7338 32.0927 34.0723 31.3646 33.9875 30.5888C33.9077 29.8592 33.4691 29.2637 33.0074 28.8118C32.2692 28.0893 31.1917 27.4814 30.4789 27.0793L30.475 27.0771Z"
        fill={fill || "#0051FF"}
      />
    </svg>
  );
};

export default CircleUserIcon;
